import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { FileText, MoreHorizontal, Search } from "lucide-react";

interface EncounterToolsMenuProps {
  variant: "ghost" | "ghostOnPrimary";
  /** Present only where this encounter has a decision log folder to open. */
  decisionLogUrl?: string;
  /** Present only where the investigator can run. */
  onOpenInvestigator?: () => void;
}

export function EncounterToolsMenu({ variant, decisionLogUrl, onOpenInvestigator }: EncounterToolsMenuProps) {
  if (!decisionLogUrl && !onOpenInvestigator) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={variant} size="sm" aria-label="More actions">
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {decisionLogUrl && (
          <DropdownMenuItem asChild className="cursor-pointer">
            <a href={decisionLogUrl} target="_blank" rel="noreferrer">
              <FileText className="h-4 w-4 mr-2" />
              View decision log
            </a>
          </DropdownMenuItem>
        )}
        {onOpenInvestigator && (
          <DropdownMenuItem onSelect={onOpenInvestigator} className="cursor-pointer">
            <Search className="h-4 w-4 mr-2" />
            Investigator
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
